

<div class="container" style="background-color: white;">
    <a class="btn btn-primary" (click)="exportAsXLSX()" style="margin-left: 0px;float: right; background-color: #747f7f;">Export Data</a>
    <a class="btn btn-primary" (click)="start_lopp()" style="margin-left: 0px;float: right; background-color: #747f7f;">Fetch Detail</a>

    <div class="col-md-12" style="padding: 5px;">
        <table style="width:100%">
            <tr>
                <th>acc_no</th>
                <th>added_at</th>
                <th>added_by</th>
                <th>bank_id</th>
                <th>bucket_id</th>
                <!-- <th>customer_details</th> -->
                
            </tr>
            <ng-container *ngFor="let item of excel_data; let i = index">
                <tr> 
                <td>{{item.acc_no}}</td>
                <td>{{item.added_by}}</td>
                <td>{{item.bank_id}}</td>
                <td>{{item.bucket_id}}</td>
                <td>{{item.client_id}}</td>
               
                  </tr>
              </ng-container>
          </table>
        </div>
    <div class="centered" style="width: 100%;background: #000000b3;height: -webkit-fill-available;" *ngIf="loader_status">
            <p><img class="imgs" src="../../../../assets/loader.gif" style="width: 10%;"></p>
            <p style="text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: white;"> Completed {{excel_data.length - 1 - timeLeft}} / {{excel_data.length}} <p>  
    </div>
    </div>